/**
 * 红点主点
 *
 * @public
 */
class MainBadge {
    constructor(info) {
        this.info = info;
        /**
         * 副点更新时的回调
         */
        this.onUpdate = () => { };
        this.subBadges = new Map();
    }
    /**
     * 向主点添加副点
     *
     * @param position - 位置类型
     * @param key - 红点标识
     * @returns 主点本身
     */
    relatedTo(position, key) {
        this.subBadges.set(`${position}-${key}`, {
            position,
            key,
        });
        this.onUpdate();
        return this;
    }
    /**
     * 从主点中移除副点
     *
     * @param position - 位置类型
     * @param key - 红点标识
     * @returns 主点本身
     */
    removeRelatedBadge(position, key) {
        const result = this.subBadges.delete(`${position}-${key}`);
        this.onUpdate();
        return result;
    }
    /**
     * 获取所有副点
     */
    get relatedBadges() {
        return [...this.subBadges.values()];
    }
}

export { MainBadge };
//# sourceMappingURL=badge.js.map
